export default __webpack_public_path__ + "static/media/warning.554f73d7.svg";